// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"51ae35c9","787":"b3cd2f50"}[chunkId] + ".chunk.js";
};